export default __webpack_public_path__ + "static/media/31.0ba590c3.jpg";